import { HisUidService } from '../../core/service/base/his-uid.service';
import { HisSearchCriteriagroup } from './his-search-criteriagroup';
import { HisWidgetBase } from './his-widget-base';

import { computed, signal } from '@angular/core';
import * as _ from 'lodash';
import { HisArrayUtils } from '../../core/utils';
import { GenericSearchUtil } from '../utils/generic-search-util';
import { HisSelectWidget } from './his-widget-select';

export class HisWidgetGroup {
    static readonly ID_DEFAULT = 'WidgetGroup.DEFAULT';

    id: string;
    label: string;
    helptext: string;
    widgets: HisWidgetBase<any>[];
    quickSearch: boolean;
    criteriaGroup: boolean;
    combineCriteriaGroupsByOr: boolean;
    get criteriaGroups(): HisSearchCriteriagroup[] {
        return this.criteriaGroupsInternal();
    }
    set criteriaGroups( value: HisSearchCriteriagroup[] ) {
        this.criteriaGroupsInternal.set( value );
    }
    
    /**
     * Defines whether this widgetGroup should be displayed in the search mask. Returns `true` if it contains a widget that should be displayed.
     */
    shouldDisplay = computed( () => this.quickSearch || this.isActiveByCriteriaGroups() || this.widgets.some(w => w.shouldDisplay()) );
    private readonly isActiveByCriteriaGroups = computed( () => HisArrayUtils.isNonEmptyArray(this.criteriaGroups) );
    private readonly criteriaGroupsInternal = signal<HisSearchCriteriagroup[]>( [] );

    constructor( options?: any ) {
        if ( !options ) { options = {}; }
        this.id = options.id || HisUidService.get( 'WidgetGroup.' );
        this.label = options.label || '';
        this.helptext = options.helptext;
        this.widgets = options.widgets || [];
        this.quickSearch = ( _.isNil( options.quickSearch ) ) ? true : !!options.quickSearch;
        this.criteriaGroup = ( _.isNil( options.criteriaGroup ) ) ? true : !!options.criteriaGroup;
        this.criteriaGroupsInternal.set( options.criteriaGroups || [] );
        this.combineCriteriaGroupsByOr = options.combineCriteriaGroupsByOr || false;
    }

    updateCriteriaGroups( callback: ( criteriaGroups: HisSearchCriteriagroup[] ) => HisSearchCriteriagroup[] ) {
        this.criteriaGroups = [...callback( this.criteriaGroups )];
    }

    presetInputFields( presets: any ) {
        for ( let widget of this.widgets ) {
            widget.presetInputFields( presets );
        }
    }

    collectLazyWidgets() {
        const lazyWidgets: HisSelectWidget[] = [];
        for ( let widget of this.widgets ) {
            if ( widget instanceof HisSelectWidget && GenericSearchUtil.isLazySelectFrom( widget.optionsKey, widget.showDropdownIcon ) ) {
                lazyWidgets.push( widget );
            }
        }
        return lazyWidgets;
    }
}
